/* Il punteggio del quiz.
 *
 * Otto domande che contano tutte e otto. È il punto: un quiz che raccoglie
 * otto risposte e ne usa una sola dà a chiunque le stesse tre pietre, e chi lo
 * rifà cambiando tutto tranne la prima risposta se ne accorge.
 *
 * I pesi non sono arbitrari. I due bisogni pesano più di tutto perché sono le
 * uniche risposte su cui la litoterapia ha davvero qualcosa da dire, e il loro
 * incrocio è ciò che restringe: una pietra che sta in due registri insieme è
 * rara. Forma e prezzo non aggiungono punti, li tolgono — una pietra
 * bellissima che non esiste in bracciale, o che parte da centoventi euro, è un
 * consiglio sbagliato per chi ha detto il contrario.
 */
(function () {
  var radice = document.querySelector('[data-quiz]');
  var dati = window.QUIZ_DATI;
  if (!radice || !dati) return;

  var domande = [].slice.call(radice.querySelectorAll('[data-quiz-domanda]'));
  var esito = radice.querySelector('[data-quiz-esito]');
  var barra = radice.querySelector('[data-quiz-barra]');
  var indietro = radice.querySelector('[data-quiz-indietro]');
  var risposte = {};
  var passo = 0;

  /* Le famiglie di colore: la domanda parla la lingua di chi guarda, i dati
     quella dei metafield. Qui si traduce, una volta sola. */
  var FAMIGLIE = {
    rosa: ['rosa', 'beige'],
    viola: ['viola'],
    caldo: ['rosso', 'arancione', 'giallo', 'dorato'],
    freddo: ['blu', 'verde', 'verde pallido'],
    scuro: ['nero', 'grigio', 'marrone'],
    chiaro: ['bianco', 'incolore', 'trasparente', 'argentato']
  };

  var ELEMENTO = {
    ariete: 'fuoco', leone: 'fuoco', sagittario: 'fuoco',
    toro: 'terra', vergine: 'terra', capricorno: 'terra',
    gemelli: 'aria', bilancia: 'aria', acquario: 'aria',
    cancro: 'acqua', scorpione: 'acqua', pesci: 'acqua'
  };

  var ETICHETTA = {
    portare: 'da portare', meditare: 'da tenere in mano',
    casa: 'per la casa', regalare: 'da regalare'
  };

  function mostra(i) {
    domande.forEach(function (d, n) { d.classList.toggle('is-attiva', n === i); });
    if (barra) barra.style.width = (i / domande.length) * 100 + '%';
    if (indietro) indietro.hidden = i === 0;
  }

  /* Tornare indietro cancella la risposta della domanda a cui si torna: se
     restasse in memoria, chi si ferma lì e ricarica la pagina si porterebbe
     dietro una scelta che credeva di aver disfatto. */
  function passoIndietro() {
    if (passo === 0) return;
    passo--;
    var chiave = domande[passo].dataset.chiave;
    delete risposte[chiave];
    esito.hidden = true;
    esito.innerHTML = '';
    mostra(passo);
    domande[passo].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  radice.addEventListener('click', function (e) {
    var b = e.target.closest('.quiz__scelta');
    if (!b) return;
    var d = b.closest('[data-quiz-domanda]');
    risposte[d.dataset.chiave] = b.dataset.val;
    passo++;
    if (passo < domande.length) {
      mostra(passo);
      d.classList.remove('is-attiva');
    } else {
      domande.forEach(function (x) { x.classList.remove('is-attiva'); });
      if (barra) barra.style.width = '100%';
      concludi();
    }
  });

  /* Il tema dà punti in base alla posizione: le liste sono già ordinate per
     pertinenza da chi ha scritto la pagina, e ignorarlo butterebbe via
     l'unica gerarchia che abbiamo. */
  function puntiTema(tema, h, pieno) {
    var lista = dati.temi[tema] || [];
    var i = lista.indexOf(h);
    if (i < 0) return 0;
    return pieno * (1 - (i / lista.length) * 0.38);
  }

  function punteggi() {
    var out = {};
    var famiglia = FAMIGLIE[risposte.colore] || [];
    var elemento = ELEMENTO[risposte.segno];
    var perElemento = (elemento && dati.elementi[elemento]) || [];
    var tetto = Number(risposte.budget || 0);

    Object.keys(dati.pietre).forEach(function (h) {
      var p = dati.pietre[h];
      var punti = 0;
      var perche = [];

      var t1 = puntiTema(risposte.tema, h, 4);
      var t2 = risposte.tema2 ? puntiTema(risposte.tema2, h, 2.5) : 0;
      punti += t1 + t2;
      if (t1 && t2) perche.push('sta in tutti e due i registri che hai scelto');
      else if (t1 || t2) perche.push('per quello che cerchi');

      /* Il segno preciso vale più dell'elemento: la pagina del segno ha una
         lista sua, l'elemento è solo il gruppo a cui appartiene. */
      if (risposte.segno && p.z.indexOf(risposte.segno) >= 0) { punti += 2; perche.push('è una pietra del tuo segno'); }
      else if (perElemento.indexOf(h) >= 0) punti += 1;

      if (famiglia.some(function (c) { return p.c.indexOf(c) >= 0; })) {
        punti += 2;
        perche.push('per il colore');
      }

      if (risposte.chakra && p.k.indexOf(risposte.chakra) >= 0) { punti += 1.5; perche.push('per la zona che hai indicato'); }

      /* Non basta che la forma esista: quasi ogni pietra ha almeno un
         ciondolo, quindi la sola presenza non distingue nulla. Quante ce ne
         sono sì — e chi non ne ha nessuna esce, perché mandare su una
         collezione senza niente di quello che si voleva è il peggior
         consiglio possibile. */
      var forma = risposte.uso && p.u[risposte.uso];
      if (risposte.uso && Object.keys(p.u).length) {
        if (!forma) punti -= 6;
        else if (forma.n >= 12) punti += 2;
        else if (forma.n >= 4) punti += 1;
      }

      /* Il prezzo si legge sulla forma chiesta, non sul catalogo intero: la
         malachite parte da otto euro in ciottolo e da centottanta in collana,
         e dire "sotto i venti" guardando il minimo assoluto sarebbe una
         mezza bugia. */
      if (tetto && forma && forma.da) {
        if (forma.da > tetto) punti -= 6;
        else if (forma.da <= tetto * 0.5) punti += 0.6;
      }

      /* Alla prima pietra si consiglia il conosciuto, non il raro: chi ne ha
         già parecchie cerca l'opposto, e chi cerca l'insolito lo cerca sul
         serio. */
      if (risposte.esperienza === 'prima') punti += p.p >= 60 ? 2 : (p.p >= 25 ? 1 : -0.5);
      else if (risposte.esperienza === 'poche') punti += p.p >= 25 ? 0.5 : 0;
      else if (risposte.esperienza === 'parecchie') punti += p.p < 40 ? 1.8 : -0.4;
      else if (risposte.esperienza === 'rara') {
        if (p.p < 20) { punti += 2.5; perche.push('è insolita'); }
        else if (p.p < 40) punti += 1;
        else punti -= 0.8;
      }

      /* A parità, vince quella di cui abbiamo di più: è anche quella che ha
         più probabilità di essere disponibile nella misura giusta. */
      punti += Math.min(p.p, 300) / 3000;

      if (punti > 0) out[h] = { punti: punti, perche: perche };
    });
    return out;
  }

  /* Il secondo link è dove la sesta risposta si vede davvero: chi ha detto
     "in casa" atterra sulle sfere e sulle druse di quella pietra, non su
     trecento prodotti da spulciare. Se i filtri della vetrina non sono attivi
     Shopify ignora i parametri e mostra la collezione intera — si perde la
     scorciatoia, non la pagina. */
  function selezione(h, p) {
    var base = '/collections/pietra-' + h;
    var u = risposte.uso && p.u[risposte.uso];
    if (!u) return { url: base, testo: p.p + ' prodotti' };
    var q = u.t.slice(0, 4).map(function (t) {
      return 'filter.p.product_type=' + encodeURIComponent(t);
    }).join('&');
    var testo = u.n + ' ' + ETICHETTA[risposte.uso];
    if (u.da) testo += ' · da ' + Math.round(u.da) + ' €';
    return { url: base + '?' + q, testo: testo };
  }

  function scheda(h, motivo) {
    var p = dati.pietre[h];
    var righe = [];
    righe.push('<article class="esito__pietra">');
    righe.push('<a class="esito__foto" href="/pages/pietra-' + h + '">');
    righe.push('<img src="' + p.f + '" alt="' + p.n + '" loading="lazy" width="320" height="320"></a>');
    righe.push('<div class="esito__testo">');
    righe.push('<h4 class="esito__nome"><a href="/pages/pietra-' + h + '">' + p.n + '</a></h4>');
    if (motivo) righe.push('<p class="esito__perche">' + motivo + '</p>');
    if (p.d) righe.push('<p class="esito__dato">' + p.d + '</p>');
    righe.push('<p class="esito__azioni">');
    righe.push('<a class="esito__vai" href="/pages/pietra-' + h + '">Leggi la scheda</a>');
    if (p.v && p.p) {
      var s = selezione(h, p);
      righe.push('<a class="esito__vai esito__vai--fioca" href="' + s.url + '">' + s.testo + '</a>');
    }
    righe.push('</p></div></article>');
    return righe.join('');
  }

  function concludi() {
    var p = punteggi();
    var ordinate = Object.keys(p).sort(function (a, b) { return p[b].punti - p[a].punti; });

    /* Se l'incrocio non lascia in piedi nessuno — succede con una forma rara
       più un budget stretto — si allarga al solo bisogno: meglio tre pietre
       pertinenti a metà che una pagina vuota. */
    if (ordinate.length < 3) {
      ordinate = (dati.temi[risposte.tema] || Object.keys(dati.pietre)).slice(0, 3);
      ordinate.forEach(function (h) { if (!p[h]) p[h] = { perche: [] }; });
    }

    /* Tre pietre che cominciano per la stessa parola non sono tre consigli:
       "legno fossile" e "legno pietrificato" sono la stessa cosa detta due
       volte, e quarzo davanti a quarzo rosa fa sembrare rotto il quiz. */
    var tre = [];
    var prese = {};
    ordinate.forEach(function (h) {
      if (tre.length >= 3) return;
      var prima = dati.pietre[h].n.split(' ')[0].toLowerCase();
      if (prese[prima]) return;
      prese[prima] = true;
      tre.push(h);
    });
    ordinate.forEach(function (h) { if (tre.length < 3 && tre.indexOf(h) < 0) tre.push(h); });

    var html = '<p class="esito__occhiello">Le tue tre pietre</p>';
    html += '<div class="esito__lista">';
    tre.forEach(function (h) {
      var m = (p[h].perche || []).slice(0, 2).join(', ');
      html += scheda(h, m ? m.charAt(0).toUpperCase() + m.slice(1) : '');
    });
    html += '</div>';

    if (risposte.tema && dati.temi[risposte.tema]) {
      html += '<p class="esito__oltre">Vuoi vedere tutte le pietre di questo registro? ';
      html += '<a href="/pages/' + risposte.tema + '">Apri la pagina completa</a>.</p>';
    }
    html += '<p class="esito__oltre"><button type="button" class="esito__ancora" data-quiz-ancora>Rifai il quiz</button></p>';

    esito.innerHTML = html;
    esito.hidden = false;
    esito.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  radice.addEventListener('click', function (e) {
    if (e.target.closest('[data-quiz-indietro]')) { passoIndietro(); return; }
    if (!e.target.closest('[data-quiz-ancora]')) return;
    risposte = {};
    passo = 0;
    esito.hidden = true;
    esito.innerHTML = '';
    mostra(0);
    radice.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  mostra(0);
}());
